import { Link } from "react-router-dom";
import { ChevronRight, ShieldCheck } from "lucide-react";
import { ToolIcon } from "@/components/iconMap";
import { AdUnit } from "@/components/AdUnit";

export function GenericToolShell({ icon, title, promise, privacy, children }) {
  return (
    <>
      <section className="relative overflow-hidden bg-slate-900">
        <div className="absolute inset-0 grid-dots opacity-10" />
        <div className="absolute -top-24 -right-24 w-96 h-96 bg-blue-600/20 rounded-full blur-3xl" />
        <div className="relative max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 pt-8 pb-12">
          <nav className="flex items-center gap-2 text-xs text-slate-400 mb-6">
            <Link to="/" className="hover:text-white">Home</Link><ChevronRight className="w-3 h-3" />
            <Link to="/ecommerce-tools" className="hover:text-white">Ecommerce Tools</Link><ChevronRight className="w-3 h-3" />
            <span className="text-slate-200">{title}</span>
          </nav>
          <div className="flex items-start gap-4">
            <div className="w-14 h-14 rounded-2xl bg-white/10 backdrop-blur flex items-center justify-center shrink-0">
              <ToolIcon name={icon} className="w-7 h-7 text-blue-300" />
            </div>
            <div>
              <h1 className="text-3xl sm:text-4xl font-extrabold text-white tracking-tight">{title}</h1>
              <p className="mt-3 text-lg text-slate-300 max-w-2xl leading-relaxed">{promise}</p>
            </div>
          </div>
        </div>
      </section>
      <section className="relative -mt-6 pb-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-white border border-slate-200 rounded-3xl p-5 sm:p-7 shadow-xl shadow-slate-200/50">
            {children}
            {privacy && (
              <p className="text-xs text-slate-500 text-center mt-5 inline-flex items-center justify-center gap-1.5 w-full">
                <ShieldCheck className="w-3.5 h-3.5 text-blue-500" /> {privacy}
              </p>
            )}
          </div>
          <AdUnit />
        </div>
      </section>
    </>
  );
}
